export const getBMHasEntitlement = (globalState, entitlements = []) => {
  const COUNTRY = `quicken-${globalState.country}`;
  return globalState.subscriptions[COUNTRY]
    ?.allEntitlements
    ?.some(arg => entitlements.includes(arg)) ?? false;
};

export const getBMPlan = (globalState) => {
  const SUB = globalState?.subscriptions?.['billmanager'];

  if (SUB?.allEntitlements) {
    return {
      current: SUB?.tierUriName,
      renewal: SUB?.renewalTierUriName ?? SUB?.tierUriName,
    };
  } else if (getBMHasEntitlement(globalState, ['BILLPAY_STANDARD'])) {
    return {current: 'standard', renewal: 'standard'};
  } else if (getBMHasEntitlement(globalState, ['BILLPAY_EXTRA'])) {
    return {current: 'extra', renewal: 'extra'};
  } else {
    return {current: null, renewal: null};
  }
};

export const getBillManagerType = (globalState) => {
  if (globalState?.subscriptions?.billmanager) return 'PAID';
  else if (getBMHasEntitlement(globalState, ['BILLPAY_STANDARD', 'BILLPAY_EXTRA'])) return 'FREE';
  else return 'NONE';
};
